<script lang="ts">
  import Loading from '../../etc/loader.svelte';
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import type { GetSubContractResult } from '../../repositories/contract';
  import { loginUser } from '../../components/auth/LoginUser';

  export let subContractId: number;
  let subContract: GetSubContractResult,
    enabledTermiante = false,
    promise = getApi();
  let display: 'INPUT' | 'CONFIRM' | 'COMPLETE' = 'INPUT';

  function onConfirm() {
    display = 'CONFIRM';
  }
  function onBack() {
    display = 'INPUT';
  }

  function displayErrorAlert(status: number) {
    if (status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      location.reload();
    } else {
      alert('エラーが発生しました。再度やり直してください。');
    }
  }

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    await contractRepository
      .getSubContract({ subContractId })
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        subContract = res;
        enabledTermiante = res.contractStatus !== '解約済' && !res.singleTerminateFlg;
      })
      .catch((error) => {
        displayErrorAlert(error.response.status);
      });
    return subContract;
  }

  async function doPost() {
    if (subContract.singleTerminateFlg) {
      alert('この付帯契約プランは解約できません。');
      return;
    }
    if (subContract.contractStatus === '解約済') {
      alert('解約済のため解約できません');
      return;
    }

    const contractRepository = RepositoryFactory[CONTRACT];
    await contractRepository
      .terminateSubContract({
        subContractId: subContract.subContractId
      })
      .then((res) => {
        display = 'COMPLETE';
      })
      .catch((error) => {
        displayErrorAlert(error.response.status);
      });
  }
</script>

{#await promise}
  <Loading />
{:then subContract}
  <div class="h-auto p-6 bg-white m-auto">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-700">
        {subContract.serviceName}
      </h1>
    </div>
    <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
      <div class="flex flex-col">
        {#if display === 'COMPLETE'}
          <div class="flex-1 mb-4">
            <div class="inline-flex justify-items-center items-center min-w-full p-6">
              <span class="">解約依頼が完了しました。</span>
            </div>
          </div>
        {:else if display === 'CONFIRM'}
          <div class="mb-10">
            アカウント： {subContract.keyAccount} を解約します。
          </div>
        {:else}
          <div class="flex-1 mt-4 mb-10">
            <div>
              ステータス：{subContract.contractStatus}
            </div>
            <div>
              アカウント：{subContract.keyAccount}
            </div>
            <div>
              パスワード：{subContract.keyAccountIkosub1}
            </div>
            <div>
              申込日：{subContract.contractStartDate}
            </div>
            <div>
              解約日：{subContract.contractEndDate ?? '-'}
            </div>
          </div>
        {/if}

        {#if display === 'INPUT'}
          <div class="flex-1 mb-10">
            <div class="shadow rounded bg-gray-200 p-4 text-sm">
              <div class="mt-3">
                ※お問い合わせは以下からご連絡いただきますようお願いします。<br />
                URL：<a href="https://bb.unext.co.jp/contact" rel="noopener noreferrer" target="_blank">
                  https://bb.unext.co.jp/contact
                </a>
              </div>
            </div>
          </div>
        {:else}
          <div class="flex-1 mb-10">
            <div class="shadow rounded bg-gray-200 p-4 text-sm">
              <div class="mt-3">
                ※契約しているISPのプランが、「にねん割」または「ず～っと割」プランの場合、更新月以外の解約の場合、違約金（5,000円）が発生します。<br
                />
                ※ISPの解約に伴い、取得いただいているメールアドレス含め、すべてのサービスが利用できなくなります。<br />
                ※解約手続き後のキャンセルはできません。<br />
                ※お問い合わせは以下からご連絡いただきますようお願いします。<br />
                URL：<a href="https://bb.unext.co.jp/contact" rel="noopener noreferrer" target="_blank">
                  https://bb.unext.co.jp/contact
                </a>
              </div>
            </div>
          </div>
        {/if}

        {#if display === 'CONFIRM'}
          <div class="flex-1">
            <div class="flex flex-col justify-items-center items-center">
              <div class="flex-1">
                <button on:click|once={onBack} class="button-primary"> 戻る </button>
                <button on:click|once={doPost} class="button-withdrawal"> 解約 </button>
              </div>
            </div>
          </div>
        {:else if display === 'INPUT'}
          <div class="flex-1">
            <div class="flex flex-col justify-items-center items-center">
              <div class="flex-1">
                <button on:click|once={onConfirm} class="button-withdrawal" disabled={!enabledTermiante}>
                  解約手続きへ
                </button>
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-withdrawal {
    @apply bg-red-100 rounded-lg hover:bg-red-200 focus:outline-none text-sm font-semibold text-red-700 px-10 py-2;
  }
  .button-withdrawal:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
